// Build information, automatically generated by `ng-info`
const build = {
    version: "2.1.0",
    timestamp: "Tue Aug 18 2026 19:48:33 GMT+0000 (Coordinated Universal Time)",
    message: null,
    git: {
        user: null,
        branch: "main",
        hash: "72f922",
        fullHash: "72f922666399c527a76d70cc899fc1c7d3576c12"
    }
};

export default build;